import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { StyledModalBackdrop, StyledModalContent } from "./Modal-styled";

const Modal = ({ show, children, hasContent = true }) => {
  const [visible, setVisible] = useState(show);
  const [animateOut, setAnimateOut] = useState(false);

  useEffect(() => {
    if (show) {
      setVisible(true);
      setAnimateOut(false);
    } else if (visible) {
      setAnimateOut(true);
      const timeout = setTimeout(() => setVisible(false), 300); // match animation duration
      return () => clearTimeout(timeout);
    }
  }, [show, visible]);

  if (!visible) return null;

  const childrenWithProps = hasContent ? (
    <StyledModalContent animateOut={animateOut}>{children}</StyledModalContent>
  ) : (
    children
  );

  return createPortal(
    <StyledModalBackdrop animateOut={animateOut}>
      {childrenWithProps}
    </StyledModalBackdrop>,
    document.querySelector("#root")
  );
};

export default Modal;
